import { Component } from '@angular/core';
import { AdminService } from '../../../../@shared/services/admin.service';
import { ToastService } from '../../../../@core/services/toast.service';

interface PlaceResult {
  place_id: string;
  name: string;
  formatted_address: string;
  address: string;
  city: string;
  postal_code: string;
  country: string;
  phone: string;
  website: string;
  opening_hours: string;
  photo_url: string | null;
  rating: number | null;
  rating_count: number | null;
  google_maps_url: string;
  adding: boolean;
  added: boolean;
}

@Component({
  selector: 'app-admin-places',
  standalone: false,
  templateUrl: './admin-places.html',
  styleUrl: './admin-places.css'
})
export class AdminPlaces {
  searchQuery: string = '';
  location: string = 'Norway';
  searching: boolean = false;
  results: PlaceResult[] = [];
  searchPerformed: boolean = false;

  constructor(
    private adminService: AdminService,
    private toastService: ToastService
  ) {}

  onSearch() {
    if (!this.searchQuery.trim()) return;

    this.searching = true;
    this.searchPerformed = true;
    this.results = [];

    this.adminService.searchPlaces(this.searchQuery, this.location).subscribe({
      next: (response) => {
        this.results = (response.data || []).map(place => ({
          ...place,
          adding: false,
          added: false
        }));
        this.searching = false;
      },
      error: () => {
        this.searching = false;
        this.toastService.error('Failed to search Google Places');
      }
    });
  }

  addPlace(place: PlaceResult) {
    place.adding = true;

    const data = {
      place_id: place.place_id,
      name: place.name,
      address: place.address,
      city: place.city,
      postal_code: place.postal_code,
      country: place.country,
      phone: place.phone,
      website: place.website,
      opening_hours: place.opening_hours,
      photo_url: place.photo_url
    };

    this.adminService.addPlaceAsCompany(data).subscribe({
      next: (response) => {
        place.adding = false;
        place.added = true;
        this.toastService.success(`${place.name} added successfully`);
      },
      error: (error) => {
        place.adding = false;
        // Error toast is handled by endpoint service
      }
    });
  }

  clearSearch() {
    this.searchQuery = '';
    this.results = [];
    this.searchPerformed = false;
  }
}
